import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Container from '@/components/Container'
import Main from '@/components/Main'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/home',
    name: 'home',
    component: Container
  },
  {
    path: '/offer/:form',
    name: 'Offer',
    component: () => import('../views/people/Offer.vue')
  },
  {
    path: '/register/:peopleId/:username',
    name: 'Register',
    component: () => import('../views/people/out/Register')
  },
  {
    path: '/register/gps',
    name: 'Register2',
    component: () => import('../views/people/out/Register2')
  },
  {
    path: '/evaluation/:username/:peopleId',
    name: 'Evaluation',
    component: () => import('../views/people/out/Evaluation')
  },
  {
    path: '/evaluationNew/:username/:peopleId',
    name: 'EvaluationNew',
    component: () => import('../views/people/out/EvaluationNew')
  },
  {
    path: '/evaluationNewV2/:username/:peopleId',
    name: 'EvaluationNewV2',
    component: () => import('../views/people/out/EvaluationNewV2')
  },
  {
    path: '/print/:peopleId',
    name: 'Print',
    component: () => import('../views/people/candidateDialog/Print')
  },
  {
    path: '/quiz/quality/:peopleId',
    name: 'QuizQuality',
    component: () => import('../views/people/out/QuizQuality')
  },
  {
    path: '/quiz/base/:peopleId',
    name: 'QuizBase',
    component: () => import('../views/people/out/QuizBase')
  },
  {
    path: '/people',
    name: 'people',
    component: Main,
    children: [
      {
        path: 'candidate',
        component: () => import('@/views/people/Candidate'),
        name: 'Candidate'
      }, {
        path: 'talent',
        component: () => import('@/views/people/Talent'),
        name: 'Talent'
      }, {
        path: 'blacklist',
        component: () => import('@/views/people/Blacklist'),
        name: 'Blacklist'
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/report',
    name: 'report',
    component: Main,
    children: [
      {
        path: 'loss',
        component: () => import('@/views/report/Loss'),
        name: '员工流失率'
      }, {
        path: 'analysis',
        component: () => import('@/views/report/Analysis'),
        name: '招聘分析'
      }, {
        path: 'stats',
        component: () => import('@/views/report/Stats'),
        name: '招聘情况统计表'
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/system',
    name: 'system',
    component: Main,
    children: [
      {
        path: 'user',
        component: () => import('@/views/system/User'),
        name: '用户管理'
      }, {
        path: 'role',
        component: () => import('@/views/system/Role'),
        name: '角色管理'
      }, {
        path: 'permission',
        component: () => import('@/views/system/Permission'),
        name: '权限管理'
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
